module.exports = __webpack_public_path__ + "static/media/Chronic Pain Management.b6db3b1b.svg";